import { RouteConfig } from 'vue-router';
import { permissionMessagesFeature } from '../Middleware/permission/Messages';

export const NAME_ROUTES_MESSAGE = {
  MESSAGES: 'mensagens'
};

export const Messages: Array<RouteConfig> = [
  {
    path: '/mensagens',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_MESSAGE.MESSAGES,
        component: () => import(
          /* webpackChunkName: "messages" */ '@/pages/Messages/index.vue'
        ),
        meta: { title: 'Mensagens' },
        beforeEnter: permissionMessagesFeature
      }
    ]
  }
];
